import enMessages from './translations/en.json';
import frMessages from './translations/fr.json';
// import deMessages from './translations/de.json';
// import esMessages from './translations/es.json';
// import itMessages from './translations/it.json';
import { AvailableLocale, IntlJsonMessages, ReactIntlMessages, ReactIntlMessagesObj } from './types';

export const availableLocales: { [key in AvailableLocale]: AvailableLocale } = {
  fr: 'fr',
  en: 'en',
  // it: 'it',
  // de: 'de',
  // es: 'es',
};

const localesMap: {
  [key: string]: AvailableLocale;
} = availableLocales;

export const getSupportedLocale = (locale: string): AvailableLocale => {
  if (localesMap[locale]) {
    return localesMap[locale];
  }
  return 'en';
};

function flattenMessages(nestedMessages: IntlJsonMessages, prefix = ''): IntlJsonMessages {
  return Object.keys(nestedMessages).reduce((messages, key: string) => {
    const value = nestedMessages[key];
    const prefixedKey = prefix ? `${prefix}.${key}` : key;

    if (typeof value === 'string') {
      return { ...messages, [prefixedKey]: value };
    }

    return { ...messages, ...flattenMessages(value, prefixedKey) };
  }, {});
}

const locales: ReactIntlMessagesObj = {
  en: {
    messages: (enMessages as unknown) as IntlJsonMessages,
    code: 'en-GB',
  },
  fr: {
    messages: (frMessages as unknown) as IntlJsonMessages,
    code: 'fr-FR',
  },
  // de: {
  //     messages: deMessages as unknown as IntlJsonMessages,
  //     code: 'de-DE',
  // },
  // es: {
  //     messages: esMessages as unknown as IntlJsonMessages,
  //     code: 'es-ES',
  // },
  // it: {
  //     messages: itMessages as unknown as IntlJsonMessages,
  //     code: 'it-IT',
  // },
};

export const getTranslations = (locale: string): ReactIntlMessages => {
  if (locale === null) {
    return {
      code: 'zu-ZU', // Zulu code is used for tests
      messages: {},
    };
  }
  const availableLocale = getSupportedLocale(locale);
  return {
    code: locales[availableLocale].code,
    messages: flattenMessages(locales[availableLocale].messages),
  };
};
